<script setup lang="ts">
withDefaults(defineProps<{
  title?: string | undefined;
  options?: string[] | number[];
  labelLeft?: string | boolean;
  labelRight?: string | boolean;
  invalid?: boolean;
}>(), {
  title: undefined,
  options: () => [1,2,3,4,5],
  labelLeft: undefined,
  labelRight: undefined,
  invalid: false,
});

const model = defineModel<number | string>();
</script>

<template>
  <div class="flex flex-col gap-2">
    <!--eslint-disable vue/no-v-html-->
    <div
      v-if="title"
      class="text-16 font-bold text-neutral-80"
      v-html="title"
    />
    <!--eslint-enable-->

    <SelectButton
      v-model="model"
      :options="options"
      aria-labelledby="basic"
      :invalid="invalid"
      class="w-full"
      :pt="{
        root: {
          class: 'flex flex-nowrap'
        },
        button: {
          class: 'py-2.5 w-full'
        },
        label: {
          class: 'text-14'
        }
      }"
    />

    <div class="flex items-center text-14 text-neutral-70">
      <div
        v-if="labelLeft"
        class="text-nowrap"
      >
        {{labelLeft}}
      </div>

      <div class="w-full" />

      <div
        v-if="labelRight"
        class="text-nowrap"
      >
        {{labelRight}}
      </div>
    </div>
  </div>
</template>
